// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import store from './store'
import permissions from './permissions/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'
import './assets/css/element.css'
import './assets/css/base.css'
import './assets/css/element-variables.scss'
import Vant from 'vant'
import 'vant/lib/index.css'
import * as echarts from 'echarts'
import * as common from './util/index.js'

Vue.use(Vant)
Vue.use(ElementUI)

// 按钮权限判断

Vue.prototype.hasPerm = permissions

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$common = common

// axios.defaults.baseURL = 'https://2f07771y51.eicp.vip/exhibitions'
// Vue.prototype.baseUrl = 'http://r20777h151.imwork.net/exhibitions'
// axios.defaults.baseURL = 'http://106.15.192.73:8080/exhibitions'
// Vue.prototype.baseUrl = 'http://106.15.192.73:8080/exhibitions'

// 高仁杰
// axios.defaults.baseURL = 'http://3434u869b7.qicp.vip/exhibitions'
// Vue.prototype.baseUrl = 'http://3434u869b7.qicp.vip/exhibitions'
//
// axios.defaults.baseURL = 'https://exshow-test.cbebaiwen.com/exhibitions'
// Vue.prototype.baseUrl = 'https://exshow-test.cbebaiwen.com/exhibitions'
// Vue.prototype.ewmUrl = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx96400ec2a395acf8&redirect_uri=https%3A%2F%2Fexshow-test.cbebaiwen.com/cbeMerchant&response_type=code&scope=snsapi_login#wechat_redirec'

axios.defaults.baseURL = 'https://exshow-web.cbebaiwen.com/exhibitions'
Vue.prototype.baseUrl = 'https://exshow-web.cbebaiwen.com/exhibitions'
Vue.prototype.ewmUrl = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxc044f7414f29ca56&redirect_uri=https%3A%2F%2Fexshow-web.cbebaiwen.com&response_type=code&scope=snsapi_login#wechat_redirec'

// 添加一个请求拦截器
axios.interceptors.request.use(
  config => {
    // if (config.url.indexOf('/api/user/login') !== -1 && config.url.indexOf('/api/user/loginByCode') === -1) {
    //   // 以multipart/form-data形式提交
    //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // } else {
    //   // 以json形式提交
    //   config.headers['Content-Type'] = 'application/json'
    // }
    // 为请求头添加token字段
    config.headers.token = sessionStorage.getItem('token')
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      // 等于600说明token过期或者token认证失败，需要从新登陆
      if (response.data.code === 600) {
        sessionStorage.clear()
        router.push(
          {
            name: 'login'
          }
        )
        return response
      } else {
        return Promise.resolve(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    if (error.response.status) {
      ElementUI.Message({
        message: error.response.data.msg,
        type: 'error'
      })
      if (error.response.data.code === 600) {
        sessionStorage.clear()
        router.push(
          {
            name: 'login'
          }
        )
      }
      return Promise.reject(error.response)
    }
  }
)

// router.beforeEach((to, from, next) => {
//   let permissions = JSON.parse(sessionStorage.getItem('routerList')) || []
//   console.log(permissions)
//   let len = permissions.filter(item => item.path === to.path).length
//   console.log(len)
//   next()
// })

// 进入路由之前执行
router.beforeEach((to, from, next) => {
  // to   将要进入的路由
  // from  将要离开的路由
  // next   让路由继续执行
  next()
  // 获取当前打开的选项卡
  store.commit('getTabs')
  // // //设置当前激活的选项卡
  // console.log('77', to)
  // const str = to.name
  // const name = str.charAt(0).toLowerCase() + str.slice(1)
  // store.commit('setActiveTabs', name)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js